import { render } from "./index.vue?vue&type=template&id=2a6c307f"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=2a6c307f&lang=scss"
script.render = render

export default script